import styled, { css } from 'styled-components';
import mq from '../../utils/mediaQueries.js';

// @ts-nocheck
var Container = styled.div.withConfig({
  displayName: "style__Container",
  componentId: "sc-1wb79b9-0"
})([".sg-flight-details__tags{margin-bottom:16px;}overflow:visible;"]);
var InnerContainer = styled.div.withConfig({
  displayName: "style__InnerContainer",
  componentId: "sc-1wb79b9-1"
})(["position:relative;"]);
var FlightDetailsItemsList = styled.div.withConfig({
  displayName: "style__FlightDetailsItemsList",
  componentId: "sc-1wb79b9-2"
})(["display:flex;justify-content:space-between;"]);
var OverlayButton = styled.button.withConfig({
  displayName: "style__OverlayButton",
  componentId: "sc-1wb79b9-3"
})(["height:100%;position:absolute;width:100%;display:none;", ""], mq.sMax(css(["display:block;"])));
var TagContainer = styled.div.withConfig({
  displayName: "style__TagContainer",
  componentId: "sc-1wb79b9-4"
})(["display:flex;margin-bottom:1rem;gap:1rem;"]);
var ItemContainer = styled.div.withConfig({
  displayName: "style__ItemContainer",
  componentId: "sc-1wb79b9-5"
})(["display:flex;flex-direction:column;padding-left:16px;width:50%;color:var(--color-grey-800);&:first-of-type{border-right:var(--color-grey-100) solid 1px;padding:0 16px 0 0;}"]);
var ItemDate = styled.span.withConfig({
  displayName: "style__ItemDate",
  componentId: "sc-1wb79b9-6"
})(["align-items:center;display:flex;"]);
var ItemDateText = styled.span.withConfig({
  displayName: "style__ItemDateText",
  componentId: "sc-1wb79b9-7"
})(["font-size:12px;text-transform:uppercase;"]);
var Item = styled.div.withConfig({
  displayName: "style__Item",
  componentId: "sc-1wb79b9-8"
})(["display:flex;padding-top:8px;", ""], mq.sMax(css(["flex-direction:column;"])));
var ItemTime = styled.div.withConfig({
  displayName: "style__ItemTime",
  componentId: "sc-1wb79b9-9"
})(["padding-bottom:2px;padding-right:8px;width:100%;", ""], mq.sMax(css(["display:flex;flex-direction:column;width:50%;"])));
var ItemTimeArrival = styled.span.withConfig({
  displayName: "style__ItemTimeArrival",
  componentId: "sc-1wb79b9-10"
})(["&&:before{content:' - ';}", ""], mq.sMax(css(["display:none;"])));
var ItemTimeInner = styled.strong.withConfig({
  displayName: "style__ItemTimeInner",
  componentId: "sc-1wb79b9-11"
})(["font-weight:700;color:var(--color-black);"]);
var ItemAirport = styled.div.withConfig({
  displayName: "style__ItemAirport",
  componentId: "sc-1wb79b9-12"
})(["color:var(--color-grey-800);", ""], mq.sMax(css(["font-size:14px;padding-top:8px;display:inline;padding-left:8px;"])));
var ItemAirportLong = styled.span.withConfig({
  displayName: "style__ItemAirportLong",
  componentId: "sc-1wb79b9-13"
})(["&:first-of-type{&::after{content:'\u2192';padding:0 4px;}}", ""], mq.sMax(css(["display:none;"])));
var ItemAirportShort = styled.span.withConfig({
  displayName: "style__ItemAirportShort",
  componentId: "sc-1wb79b9-14"
})(["&:last-of-type{&::before{content:'\u2192';padding:0 4px;}}", ""], mq.s(css(["display:none;"])));
var ItemFlight = styled.div.withConfig({
  displayName: "style__ItemFlight",
  componentId: "sc-1wb79b9-15"
})(["display:flex;flex-direction:column;", ""], mq.s(css(["width:50%;"])));
var ItemFlightTime = styled.span.withConfig({
  displayName: "style__ItemFlightTime",
  componentId: "sc-1wb79b9-16"
})([".flight-time-link{text-align:left;", "}padding-bottom:8px;display:flex;flex-wrap:wrap;@media (min-width:768px) and (max-width:974px){padding-bottom:6px;}"], mq.s(css(["font-size:14px;height:16px;&::after{font-size:10px;}"])));
var ItemFlightTimeTotal = styled.strong.withConfig({
  displayName: "style__ItemFlightTimeTotal",
  componentId: "sc-1wb79b9-17"
})(["font-weight:700 color:var(--color-black);padding-right:8px;", ""], mq.sMax(css(["display:none;"])));
var ItemFlightCarrier = styled.span.withConfig({
  displayName: "style__ItemFlightCarrier",
  componentId: "sc-1wb79b9-18"
})(["align-items:center;display:flex;font-size:14px;.carrier-logo{height:12px;margin-right:8px;width:auto;}"]);

export { Container, FlightDetailsItemsList, InnerContainer, Item, ItemAirport, ItemAirportLong, ItemAirportShort, ItemContainer, ItemDate, ItemDateText, ItemFlight, ItemFlightCarrier, ItemFlightTime, ItemFlightTimeTotal, ItemTime, ItemTimeArrival, ItemTimeInner, OverlayButton, TagContainer };
//# sourceMappingURL=style.js.map
